import { REQUEST, SUCCESS, FAILURE } from '../../../store'
import {
  LOAD_TASK_CATEGORIES,
  LOAD_TASK_USER_LIST,
  LOAD_TASK_ASSIGNEE_MYSELF,
  REGISTER_NEW_TASK,
  LOAD_TASKS,
  UPDATE_TASK,
  DELETE_TASK,
  DELETE_SELECTED_TASKS,
  UPDATE_TASK_ORDER,
  UPDATE_SELECTED_TASKS,
  LOAD_MORE_TASKS,
  LOAD_UNREAD_TASKS,
  UPDATE_READ_STATUS,
  UPDATE_STATUS_FILTER
} from './constants'

export function loadTaskCategories() {
  return {
    type: REQUEST(LOAD_TASK_CATEGORIES)
  }
}

export function loadTaskCategoriesSuccess(data) {
  return {
    type: SUCCESS(LOAD_TASK_CATEGORIES),
    data
  }
}

export function loadTaskCategoriesError(error) {
  return {
    type: FAILURE(LOAD_TASK_CATEGORIES),
    error
  }
}

export function loadTaskUserList(payload) {
  return {
    type: REQUEST(LOAD_TASK_USER_LIST),
    payload
  }
}

export function loadTaskUserListSuccess(data) {
  return {
    type: SUCCESS(LOAD_TASK_USER_LIST),
    data
  }
}

export function loadTaskUserListError(error) {
  return {
    type: FAILURE(LOAD_TASK_USER_LIST),
    error
  }
}

export function loadAssigneeMyself(payload) {
  return {
    type: LOAD_TASK_ASSIGNEE_MYSELF,
    payload
  }
}

export function registerNewTask(payload) {
  return {
    type: REQUEST(REGISTER_NEW_TASK),
    payload
  }
}

export function loadTasks(payload) {
  return {
    type: REQUEST(LOAD_TASKS),
    payload
  }
}

export function loadTasksSuccess(data) {
  return {
    type: SUCCESS(LOAD_TASKS),
    data
  }
}

export function loadTasksError(error) {
  return {
    type: FAILURE(LOAD_TASKS),
    error
  }
}

export function updateTask(payload) {
  return {
    type: REQUEST(UPDATE_TASK),
    payload
  }
}

export function updateTaskSuccess() {
  return {
    type: SUCCESS(UPDATE_TASK)
  }
}

export function updateTaskError(error) {
  return {
    type: FAILURE(UPDATE_TASK),
    error
  }
}

export function deleteTask(payload) {
  return {
    type: REQUEST(DELETE_TASK),
    payload
  }
}

export function deleteTaskSuccess() {
  return {
    type: SUCCESS(DELETE_TASK)
  }
}

export function deleteTaskError(error) {
  return {
    type: FAILURE(DELETE_TASK),
    error
  }
}

export function deleteSelectedTasks(payload) {
  return {
    type: REQUEST(DELETE_SELECTED_TASKS),
    payload
  }
}

export function deleteSelectedTasksSuccess() {
  return {
    type: SUCCESS(DELETE_SELECTED_TASKS)
  }
}

export function deleteSelectedTasksError(error) {
  return {
    type: FAILURE(DELETE_SELECTED_TASKS),
    error
  }
}

export function updateTaskOrder(payload) {
  return {
    type: REQUEST(UPDATE_TASK_ORDER),
    payload
  }
}

export function updateTaskOrderSuccess() {
  return {
    type: SUCCESS(UPDATE_TASK_ORDER)
  }
}

export function updateTaskOrderError(error) {
  return {
    type: FAILURE(UPDATE_TASK_ORDER),
    error
  }
}

export function updateSelectedTasks(payload) {
  return {
    type: REQUEST(UPDATE_SELECTED_TASKS),
    payload
  }
}

export function loadMoreTasks(payload) {
  return {
    type: REQUEST(LOAD_MORE_TASKS),
    payload
  }
}

export function loadMoreTasksSuccess(data) {
  return {
    type: SUCCESS(LOAD_MORE_TASKS),
    data
  }
}

export function loadMoreTasksError(error) {
  return {
    type: FAILURE(LOAD_MORE_TASKS),
    error
  }
}

export function loadUnreadTasks() {
  return {
    type: REQUEST(LOAD_UNREAD_TASKS)
  }
}

export function loadUnreadTasksSuccess(data) {
  return {
    type: SUCCESS(LOAD_UNREAD_TASKS),
    data
  }
}

export function loadUnreadTasksError(error) {
  return {
    type: FAILURE(LOAD_UNREAD_TASKS),
    error
  }
}

export function updateReadStatus(payload) {
  return {
    type: REQUEST(UPDATE_READ_STATUS),
    payload
  }
}

export function updateReadStatusSuccess() {
  return {
    type: SUCCESS(UPDATE_READ_STATUS)
  }
}

export function updateReadStatusError(error) {
  return {
    type: FAILURE(UPDATE_READ_STATUS),
    error
  }
}

export function updateStatusFilter(payload) {
  return {
    type: UPDATE_STATUS_FILTER,
    payload
  }
}
